import React, { FC } from 'react';
import styled from 'styled-components';
import { Avatar } from 'components/atoms/avatar';
import { Header } from './components';
import styles from './group.module.css';

interface Props {
  company: {
    id: number;
    name: string;
    type: string;
    companyUrl?: string;
  };
}

const CompanyLogo = styled(Avatar)`
  margin-right: var(--spacing-04);
`;

export const AccountsHeader: FC<Props> = ({
  company: { name, companyUrl },
  children,
}) => {
  return (
    <Header className={styles.header}>
      <Header.Primary>
        <CompanyLogo name={name} />
        <Header.PrimaryBlock>
          <div title={name} className={`${styles.title} ${styles.ellipsis}`}>
            {name}
          </div>
          {companyUrl !== null ? (
            <div className={`${styles.subtitle} ${styles.ellipsis}`}>
              {companyUrl}
            </div>
          ) : null}
        </Header.PrimaryBlock>
      </Header.Primary>
      <Header.Hanger>{children}</Header.Hanger>
    </Header>
  );
};
